export default [
  {
    title: 'Fitness Group',
    category: 'تصميم',
    featured: 'fitness-group',
    slug: 'fitness-group',
    services: [
      'تصميم'
    ],
    images: [
      'fitness',
      'fitness-behance-2'
    ]
  },
  {
    title: 'Vasty',
    category: 'تصوير',
    featured: 'vasty-cover',
    slug: 'vasty',
    services: [
      'تصميم',
      'تصوير'
    ],
    images: [
      'vasty-behance'
    ]
  },
  {
    title: 'AED',
    category: 'تصميم',
    featured: 'aed-cover',
    slug: 'academic-education-development',
    services: [
      'تصميم'
    ],
    images: [
      'aed-behance'
    ]
  },
  {
    title: 'تصاميم رمضان',
    category: 'تصميم',
    featured: 'ramadan-cover',
    slug: 'ramadan',
    services: [
      'تصميم'
    ],
    images: [
      'ramadan-behance'
    ]
  }
]
